import { apiInfo, fetchRequest, HTTPMethod, Resource } from './api';

export const getUserRoles = () => {
  return fetchRequest(
    HTTPMethod.GET,
    `${apiInfo.base}/${Resource.USERS_PERMISSIONS}/roles`
  );
}